import { default as employeeEducationDegreesTypes } from "./types";

const {
  FETCH_EMPLOYEE_EDUCATION_DEGREES_REQUEST,
  FETCH_EMPLOYEE_EDUCATION_DEGREES_SUCCESS,
  FETCH_EMPLOYEE_EDUCATION_DEGREES_FAILURE,
} = employeeEducationDegreesTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_EDUCATION_DEGREES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_EMPLOYEE_EDUCATION_DEGREES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_EMPLOYEE_EDUCATION_DEGREES_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
